import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AlertModule } from 'src/app/shared/components/alert/alert.module';
import { CartModule } from 'src/app/shared/components/cart/cart.module';
import { CartService } from 'src/app/shared/services/cart.service';
import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { PaymentFormModule } from 'src/app/shared/components/payment-form/payment-form.module';
import { ProductChoiceModule } from 'src/app/shared/components/product-choice/product-choice.module';

import { SelfAttendanceUpgradeComponent } from './upgrade.component';
import {  MatIconModule } from '@angular/material/icon';
import { MobileDropdownModule } from 'src/app/shared/components/mobile-dropdown/mobile-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    AlertModule,
    CartModule,
    HeroModule,
    PaymentFormModule,
    ProductChoiceModule,
    MatIconModule,
    MobileDropdownModule
  ],
  exports: [
    SelfAttendanceUpgradeComponent
  ],
  providers: [
    CartService
  ],
  declarations: [
    SelfAttendanceUpgradeComponent
  ]
})

export class SelfAttendanceUpgradeModule { }
